export const appAIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path d="M0 0H24V24H0z"/><path fill="currentColor" d="M12.77 7L17 17h-1.73l-.944-2.308H9.657L8.73 17H7l4.23-10h1.54zM12 8.908l-1.714 4.246h3.428L12 8.908z"/></g></svg>`,
    name: 'a' as const
};